import { render } from "./accountPersonalDataInfo.vue?vue&type=template&id=29c9f262"
import script from "./accountPersonalDataInfo.vue?vue&type=script&lang=js"
export * from "./accountPersonalDataInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__